var _line, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOfMemoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.64645,
    y1: 23.6464,
    x2: 23.6464,
    y2: 4.64645,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5H8.1875V17.625C8.1875 17.4062 8.37891 17.1875 8.625 17.1875C8.84375 17.1875 9.0625 17.4062 9.0625 17.625V18.5H11.6875V17.625C11.6875 17.4062 11.8789 17.1875 12.125 17.1875C12.3438 17.1875 12.5625 17.4062 12.5625 17.625V18.5H15.1875V17.625C15.1875 17.4062 15.3789 17.1875 15.625 17.1875C15.8438 17.1875 16.0625 17.4062 16.0625 17.625V18.5H18.6875V17.625C18.6875 17.4062 18.8789 17.1875 19.125 17.1875C19.3438 17.1875 19.5625 17.4062 19.5625 17.625V18.5H21.75V15.875H6V18.5ZM21.75 10.2695V9.3125C21.75 8.60156 21.1484 8 20.4375 8H7.3125C6.57422 8 6 8.60156 6 9.3125V10.2695C6.49219 10.4609 6.875 10.9531 6.875 11.5C6.875 12.0742 6.49219 12.5664 6 12.7578V15H21.75V12.7578C21.2305 12.5664 20.875 12.0742 20.875 11.5C20.875 10.9531 21.2305 10.4609 21.75 10.2695ZM11.25 12.8125C11.25 13.0586 11.0312 13.25 10.8125 13.25H9.9375C9.69141 13.25 9.5 13.0586 9.5 12.8125V10.1875C9.5 9.96875 9.69141 9.75 9.9375 9.75H10.8125C11.0312 9.75 11.25 9.96875 11.25 10.1875V12.8125ZM14.75 12.8125C14.75 13.0586 14.5312 13.25 14.3125 13.25H13.4375C13.1914 13.25 13 13.0586 13 12.8125V10.1875C13 9.96875 13.1914 9.75 13.4375 9.75H14.3125C14.5312 9.75 14.75 9.96875 14.75 10.1875V12.8125ZM18.25 12.8125C18.25 13.0586 18.0312 13.25 17.8125 13.25H16.9375C16.6914 13.25 16.5 13.0586 16.5 12.8125V10.1875C16.5 9.96875 16.6914 9.75 16.9375 9.75H17.8125C18.0312 9.75 18.25 9.96875 18.25 10.1875V12.8125Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26.75,
    height: 25.5,
    rx: 12.75,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfMemoryIcon);
export default __webpack_public_path__ + "static/media/out-of-memory-icon.7696b599964bfb61ab28b16ff1182425.svg";
export { ForwardRef as ReactComponent };